import services from '../../services'

const state = {
    userStatusData: []
}

const mutations = {
    setUserStatusData(state, data) {
        state.userStatusData = data
    }
}

const actions = {
    getUserPermission(context, { params, pageVO, callback }) {
        return new Promise((resolve, reject) => {
            services.userPermissionSer.getUserPermission({ params, pageVO }).then((res) => {
                resolve(res)
            }).catch(() => {
                callback()
            })
        });
    },
    delUserPermission(context, { param, callback }) {
        return new Promise((resolve, reject) => {
            services.userPermissionSer.delUserPermission(param).then((res) => {
                resolve(res)
            }).catch((res) => {
                if (res && res.response && res.response.data && res.response.data.message) {
                    callback(res.response.data.message)
                } else {
                    callback()
                }
            })
        })
    },
    postponeUserPermission(context, { param, callback }) {
        return new Promise((resolve, reject) => {
            services.userPermissionSer.postponeUserPermission(JSON.stringify(param)).then((res) => {
                resolve(res)
            }).catch((res) => {
                if (res && res.response && res.response.data && res.response.data.message) {
                    callback(res.response.data.message)
                } else {
                    callback()
                }
            })
        })
    },
    addUserPermission(context, { param, callback }) {
        return new Promise((resolve, reject) => {
            services.userPermissionSer.addUserPermission(param).then((res) => {
                callback()
                resolve(res)
            }).catch((res) => {
                if (res && res.response && res.response.data && res.response.data.message) {
                    callback(res.response.data.message)
                } else {
                    let msg = '保存成功'
                    callback(msg)
                }
            })
        })
    },
    getSinglePerm(context, callback) {
        return new Promise((resolve, reject) => {
            services.userPermissionSer.getSinglePerm().then((res) => {
                resolve(res)
            }).catch(() => {
                callback()
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
